import { render, staticRenderFns } from "./ChannelContributors.vue?vue&type=template&id=6810303e&scoped=true"
import script from "./ChannelContributors.vue?vue&type=script&lang=js"
export * from "./ChannelContributors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810303e",
  null
  
)

export default component.exports